import {
  validateCPF,
  validateDate,
  validateEmail,
  validateFieldIsBetween,
  validateFieldIsGreaterThan,
  validateFieldLength,
  validateFieldWithMatch,
  validateOnlyNumbers,
  validateRequiredField,
} from "utils/ValidationsUtils";

/** Define as respostas possíveis para o retorno do hook */
export interface IValidate {
  valid: boolean;
  error: Error | null;
}

/** Regras de validação aceitas no hook */
const ValidationsDictionary = {
  required: ({ field, value }) => validateRequiredField(field, value, true),
  match: ({ field, value, regex }) =>
    validateFieldWithMatch(field, value, regex),
  greaterThan: ({ field, value, valueToCompare }) =>
    validateFieldIsGreaterThan(field, value, valueToCompare),
  between: ({ field, value, min, max }) =>
    validateFieldIsBetween(field, value, min, max),
  length: ({ field, value, min, max, equal }) =>
    validateFieldLength(field, value, { min, max, equal }),
  email: ({ field, value }) => validateEmail(field, value),
  cpf: ({ field, value }) => validateCPF(field, value),
  date: ({ field, value }) => validateDate(field, value),
  onlyNumbers: ({ field, value }) => validateOnlyNumbers(field, value),
};

export function validateWithRule(
  rule: string,
  field: string,
  value,
  params?
): IValidate {
  try {
    if (rule && ValidationsDictionary[rule])
      ValidationsDictionary[rule]({ field, value, ...params });
  } catch (error) {
    return {
      valid: false,
      error: error as Error,
    };
  }

  return {
    valid: true,
    error: null,
  };
}
